import React, { useEffect, useState } from "react";
import { Table, Tag, Select, Space, message } from "antd";
import { format } from "date-fns";
import emailCampaignApi from "../../../api/emailCampaignApi";

const STATUS_TAG = {
    sent: { color: "success", label: "Đã gửi" },
    failed: { color: "error", label: "Thất bại" },
    queued: { color: "warning", label: "Đang chờ" },
};

const PAGE_SIZE = 50;

/**
 * Bảng log gửi email của một chiến dịch — phân trang, lọc theo trạng thái.
 * Props: campaignId (string)
 */
function EmailCampaignLogsTable({ campaignId }) {
    const [logs, setLogs] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState(undefined);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchLogs(1, statusFilter);
        setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [campaignId, statusFilter]);

    const fetchLogs = async (currentPage, status) => {
        try {
            setLoading(true);
            const offset = (currentPage - 1) * PAGE_SIZE;
            const { data } = await emailCampaignApi.getCampaignLogs(campaignId, {
                limit: PAGE_SIZE,
                offset,
                status,
            });
            setLogs(data.data.items || []);
            setTotal(data.data.total || 0);
        } catch {
            message.error("Không thể tải danh sách gửi");
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: "Email",
            dataIndex: "email",
            ellipsis: true,
        },
        {
            title: "User ID",
            dataIndex: "userId",
            width: 90,
            align: "right",
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            width: 110,
            render: (s) => {
                const t = STATUS_TAG[s] || { color: "default", label: s };
                return <Tag color={t.color}>{t.label}</Tag>;
            },
        },
        {
            title: "Gửi lúc",
            dataIndex: "sentAt",
            width: 150,
            render: (ts) => ts ? format(new Date(Number(ts)), "dd/MM HH:mm:ss") : "-",
        },
        {
            title: "Lỗi",
            dataIndex: "errorMsg",
            ellipsis: true,
            render: (v) => v ? <span className="text-red-500 text-xs">{v}</span> : null,
        },
    ];

    return (
        <div>
            <div className="flex flex-wrap gap-3 justify-between items-center mb-3">
                <span className="text-sm text-content-3">Tổng: {total.toLocaleString()} bản ghi</span>
                <Space>
                    <Select
                        allowClear
                        placeholder="Lọc trạng thái"
                        style={{ width: 150 }}
                        value={statusFilter}
                        onChange={setStatusFilter}
                        options={[
                            { value: "sent", label: "Đã gửi" },
                            { value: "failed", label: "Thất bại" },
                            { value: "queued", label: "Đang chờ" },
                        ]}
                    />
                </Space>
            </div>
            <Table
                rowKey="logId"
                dataSource={logs}
                columns={columns}
                loading={loading}
                size="small"
                scroll={{ x: "max-content" }}
                pagination={{
                    current: page,
                    pageSize: PAGE_SIZE,
                    total,
                    showSizeChanger: false,
                    onChange: (p) => {
                        setPage(p);
                        fetchLogs(p, statusFilter);
                    },
                }}
            />
        </div>
    );
}

export default EmailCampaignLogsTable;
